/**
 * Utilitaires pour la gestion de l'authentification
 */
import { setSession } from './jwt';

/**
 * Déconnecte l'utilisateur en supprimant les tokens et réinitialisant l'authentification
 */
export const logout = () => {
  // Utiliser setSession pour nettoyer proprement l'authentification
  setSession({});
};
